import {IS_SUPER_HEAD, ROLE_AMBASSADOR, ROLE_ENJOY} from "../../permissions/roleTypes";
import CheckboxFormikInput from "../inputs/CheckboxFormikInput";
import InputImage from "../inputs/InputImage";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import * as Yup from "yup";
import {ErrorMessage, Field, Form, Formik} from "formik";
import styled from "styled-components";
import SendFormButton from "../buttons/SendFormButton";
import {loadStrategy, patchStrategy} from "./strategyAction";
import Loader from "../progress-bar/Loader";
import {displayAlert} from "../../utils/utils";
import homeSVG from "../../images/nav/home.svg";
import YesNoModal from "../modal/YesNoModal";
import useImageChange from "../../custom-hooks/useImageChange";
import {loadCurrentUser} from "../user/usersAction";

const PersonalisationSection = () => {
  const { isLoading, name, id, image, status, activity, useAssistant, useLearning } =
    useSelector((state) => state.strategy);

  const currentUser = useSelector((state) => state.currentUser);

  const dispatch = useDispatch();
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const {
    imageSize,
    lengthError,
    image: strategyImage,
    onImageChange,
    onImageDelete,
  } = useImageChange(id, image, homeSVG, "strategies");

  useEffect(() => {
    dispatch(loadStrategy());
    dispatch(loadCurrentUser());
  }, [dispatch]);

  const handleSubmit = async (data) => {
    await dispatch(patchStrategy(id, data));
    await dispatch(loadStrategy())
  };
  const SignupSchema = Yup.object().shape({
    name: Yup.string()
      .min(1, "Le nom est trop court  ")
      .max(70, "Le nom est trop long"),
    activity: Yup.string()
        .max(4000, "L'activité ne doit pas dépasser 4000 caractères")
  });

  if (isLoading) {
    return <Loader />;
  }

  const imageChange = async (e) => {
    await onImageChange(e);
    dispatch(loadStrategy());
  };

  const handleImageDelete = async () => {
    await onImageDelete();
    await dispatch(loadStrategy());
    setIsOpenDeleteModal(false);
  };

  return (
    <Section>
      {displayAlert(status !== 0 && status !== 200, status === 200)}
      <h1> Personnaliser votre stratégie </h1>
      <p>
        {" "}
        Changer le logo d'accueil pour mettre le votre et modifier le nom de
        votre stratégie{" "}
      </p>

      <Container>
        <Formik
          initialValues={{
            name,
            activity,
            useAssistant,
            useLearning,
          }}
          validationSchema={SignupSchema}
          onSubmit={handleSubmit}
        >
          {() => (
            <Form>
              <InputImage
                name={"choisir une image pour votre stratégie"}
                image={strategyImage}
                onChange={imageChange}
                setOpenDeleteModal={setIsOpenDeleteModal}
              />
              {lengthError && (
                <p className={"error-text"}>
                  {" "}
                  La taille de votre image est trop importante, veuillez choisir
                  une taille inférieure à 1Mo ({imageSize})
                </p>
              )}
              <Field
                name="name"
                type={"text"}
                placeholder={"Nom de la stratégie"}
              />
              <ErrorMessage
                name="name"
                render={(msg) => (
                  <div>
                    <p className="error-text"> {msg} </p>
                  </div>
                )}
              />

                <>
                  <p>Activité de l'organisation : </p>
                  <Field
                      name="activity"
                      as="textarea"
                    type={"text"}
                    placeholder={"Activité de l'organisation"}
                    style={{height: '250px'}}
                    disabled={!IS_SUPER_HEAD(currentUser.roles)}
                  />

                  <ErrorMessage
                    name="activity"
                    render={(msg) => (
                      <div>
                        <p className="error-text"> {msg} </p>
                      </div>
                    )}
                  />

                  <CheckboxFormikInput
                    label={"Activation Enjoy Coach "}
                    name={"useAssistant"}
                    disabled={!currentUser.roles.includes(ROLE_ENJOY)}
                  />
                  <CheckboxFormikInput
                      label={"Activation EYB Learning "}
                      name={"useLearning"}
                      disabled={!currentUser.roles.includes(ROLE_ENJOY)}
                  />

                </>

              <SendFormButton state={true} actionName={"Modifier"} />
            </Form>
          )}
        </Formik>
        {isOpenDeleteModal && (
          <YesNoModal
            name={"cette image "}
            setOpenModal={setIsOpenDeleteModal}
            id={image}
            handleClickYesAction={handleImageDelete}
          />
        )}
      </Container>
    </Section>
  );
};

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`;
const Container = styled.div`
  width: 100%;
  gap: 1rem;

  form {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    flex-grow: 1;
    justify-content: space-between;

    input[type="text"] {
      border-radius: 10px;
      padding: 0.5rem;
      border: 1px solid rgba(166, 172, 181, 0.3);
      background-color: #eee;
      outline: none;
      width: 100%;

      &:focus {
        border-color: rgba(51, 148, 246, 1);
      }
    }

    button {
      align-self: flex-start;
    }
  }
`;

export default PersonalisationSection;
